module.exports = __webpack_public_path__ + "img/logo-blacheyong-co.2d2b4391.svg";